// extracted by mini-css-extract-plugin
export var layout = "index-module--layout--1KzTO";
export var content = "index-module--content--3CKkZ";